import { useState, useCallback } from 'react';

function useDebounce(
  initialVal: string,
  delay: number,
  callback: (arg0: string) => void,
): [string, (event: React.ChangeEvent<HTMLInputElement>) => () => void] {
  const [val, setValue] = useState<string>(initialVal);
  const [timer, setTimer] = useState<number>();

  const handleInputChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const inputVal = event.target.value;
      setValue(inputVal);
      if (timer) {
        clearTimeout(timer);
      }
      const timerId = window.setTimeout(() => callback(inputVal), delay);
      setTimer(timerId);

      return () => {
        if (timer) {
          clearTimeout(timer);
        }
      };
    },
    [callback, delay, timer],
  );

  return [val, handleInputChange];
}

export default useDebounce;
